import GoalsSerializer from './base';

export default class Category extends GoalsSerializer {}
